import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cohere-r-plus',
  templateUrl: './cohere-r-plus.component.html',
  styleUrls: ['./cohere-r-plus.component.scss']
})
export class CohereRPlusComponent {
  constructor(public dialogRef: MatDialogRef<CohereRPlusComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
